// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"5d5b1eb6","460":"c64cf1da","558":"d0ec9521","676":"29943f34","768":"d48ec0fd","791":"4cb9e756","865":"1573157d","872":"f1f4d7a1","969":"1e2d9cfc"}[chunkId] + ".chunk.js";
};